/* eslint-disable no-unused-vars */
import ApiFetch from 'utils/apiFetch';

const ApiFetchInstance = ApiFetch();

export const URLS = {
  promotions: '/loyalty-points/promotions',
  promotion: (id) => `/loyalty-points/promotions/${id}`,
  points: '/loyalty-points/points',
  coupons: '/loyalty-points/coupon/status',
};

export default {
  async getPromotions() {
    return ApiFetchInstance.get(URLS.promotions);
  },
  async createPromotion(id) {
    return ApiFetchInstance.post(URLS.promotion(id));
  },
  async getPoints() {
    return ApiFetchInstance.get(URLS.points);
  },
  async getCoupons() {
    return ApiFetchInstance.get(URLS.coupons);
  },
};
